import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Use current host so API/websocket are same-origin (avoids CORS when accessing via 192.168.1.25)
const apiBase =
  typeof window !== "undefined"
    ? window.location.origin
    : "http://100.120.230.21";

export const endpointLink = `${apiBase}/api/`;
export const websocketLink =
  typeof window !== "undefined"
    ? `${window.location.protocol === "https:" ? "wss" : "ws"}://${window.location.host}/websocket`
    : "ws://100.120.230.21/websocket";

const CHUNK_RELOAD_FLAG = 'odp-fpm-chunk-reload-attempted';

const isChunkLoadFailure = (error: unknown): boolean => {
  const message = String(
    (error as { message?: unknown })?.message ??
    (error as { reason?: { message?: unknown } })?.reason?.message ??
    error
  );
  return /ChunkLoadError|Loading chunk [\d]+ failed|Unexpected token '<'/.test(message);
};

const recoverFromChunkLoadFailure = () => {
  if (typeof window === 'undefined') return;
  if (sessionStorage.getItem(CHUNK_RELOAD_FLAG) === '1') return;
  sessionStorage.setItem(CHUNK_RELOAD_FLAG, '1');
  const bust = Date.now();
  const nextUrl = `${window.location.origin}${window.location.pathname}?v=${bust}${window.location.hash}`;
  window.location.replace(nextUrl);
};

if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    if (isChunkLoadFailure(event.error ?? event.message)) {
      recoverFromChunkLoadFailure();
    }
  });

  window.addEventListener('unhandledrejection', (event) => {
    if (isChunkLoadFailure(event.reason)) {
      recoverFromChunkLoadFailure();
    }
  });

  // Clear one-time guard after a successful boot so future deploys can recover.
  sessionStorage.removeItem(CHUNK_RELOAD_FLAG);
}

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
